import { render, staticRenderFns } from "./DailyChallengeDisputes.vue?vue&type=template&id=c4e09980&scoped=true&"
import script from "./DailyChallengeDisputes.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeDisputes.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeDisputes.vue?vue&type=style&index=0&id=c4e09980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e09980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c4e09980', component.options)
    } else {
      api.reload('c4e09980', component.options)
    }
    module.hot.accept("./DailyChallengeDisputes.vue?vue&type=template&id=c4e09980&scoped=true&", function () {
      api.rerender('c4e09980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeDisputes.vue"
export default component.exports